// extracted by mini-css-extract-plugin
export default {"clickable":"_1jun0mBM-D4JvErwlR-mR1","actionBtnIcon":"_3NyOrQoEjVky9WL7SqCx8Y"};